module.exports = __webpack_public_path__ + "static/jha-9ebba9298b649432af05a25f159ac9b6.png";